//
//
//
//
//
//

import { format, sub, add } from "date-fns";
import { 
	computePosition, 
	flip, 
	shift, 
	offset,
	arrow
} from "@floating-ui/dom";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";

import AppPopup from './Popup';
import sameOriginCheck from "../../../global/mixins/sameOriginCheck";

import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
	name: "AppCalendar",
	props: {
		results: Array
	},
	components: {
		FullCalendar,
		AppPopup,
	},
	data() {
		return {
			calendarOptions: {
				height: "auto",
				plugins: [dayGridPlugin],
				initialView: "dayGridMonth",
				events: null,
				headerToolbar: {
					left: 'prev',
					center: 'title',
					right: 'next'
				},
				eventTimeFormat: {
					hour: "numeric",
					minute: "numeric",
					meridiem: "short"
				},
				eventMouseEnter: this.startHoverTimer,
				eventMouseLeave: this.clearHoverTimer,
				eventClick: this.handleClick,
				// This below handles the month change event
				datesSet: event => {
					// As the calendar starts from prev month and end in next month I take the day between the range
					var midDate = new Date((event.start.getTime() + event.end.getTime()) / 2);
					this.currentMonthDate = midDate;
					this.handleMonthChange(midDate);
				}
			},
			activeHoverResult: null,
			popupEl: null,
			hoverTimer: null,
			currentMonthDate: null,
		};
	},
	computed: {},
	methods: {
		...mapMutations(["setFilterValueWithId", "setStateValue", "firstRequestSent"]),
		...mapActions(["executeSearch"]),
		eventHover(info) {
			const hoveredEvent = info.el;
			this.activeHoverResult = this.results.find(result => result.id == info.event.id);
			const arrowElement = this.popupEl.querySelector(".app-popup__pointer");
			computePosition(hoveredEvent, this.popupEl, {
				placement: "top-start",
				middleware: [
					flip(), 
					shift(), 
					offset(4), 
					arrow({element: arrowElement})
				]
			}).then(({x,y, placement, middlewareData}) => {
				Object.assign(this.popupEl.style, {top: `${y}px`, left: `${x}px`});
				
				// Accessing the data
				const {x: arrowX, y: arrowY} = middlewareData.arrow;
			
				const staticSide = {
					top: 'bottom',
					right: 'left',
					bottom: 'top',
					left: 'right',
				}[placement.split('-')[0]];

				let adjustedX = arrowX;
				if (arrowX > 450) adjustedX = 450;
				Object.assign(arrowElement.style, {
					left: adjustedX != null ? `${adjustedX}px` : '',
					top: arrowY != null ? `${arrowY}px` : '',
					right: '',
					bottom: '',
					[staticSide]: '-8px',
				});
			});
			
		},
		startHoverTimer(info) {
			const hoveredEvent = info.el;
			this.hoverTimer = setTimeout(() => {
				if (hoveredEvent.matches("*:hover") || this.popupEl.matches("*:hover")) {
					this.eventHover(info);
				} else this.clearHoverTimer();
			}, 350);
		},
		clearHoverTimer() {
			if (this.hoverTimer) {
				clearTimeout(this.hoverTimer);
				this.hoverTimer = null;
			}
		},
		handleClick(info) {
			info.jsEvent.preventDefault();
			const url = info.el.getAttribute("href");
			const external = !sameOriginCheck(url, window.location);
			if (external || this.config.openInNewWindow) {
				window.open(url, "_blank");
			} else {
				window.open(url, "_self");
			}
		},
		handleMonthChange(midDate) {
			// Since setDates occurs when page is loaded, we skip the first instance since that is already handled in App.vue
			if (!this.firstRequestSent) return;
			this.activeHoverResult = null;
			let current = format(midDate, "LLLL_yyyy").toLowerCase();
			let previous = format(sub(midDate, {months: 1}), "LLLL_yyyy").toLowerCase();
			let next = format(add(midDate, {months: 1}), "LLLL_yyyy").toLowerCase();

			// This is to prevent the calendar from showing events from formerly selected months that arne't relevant to this new search
			let oneTooLate = format(add(midDate, {months: 2}), "LLLL_yyyy").toLowerCase();
			let oneTooEarly = format(sub(midDate, {months: 2}), "LLLL_yyyy").toLowerCase();

			this.setFilterValueWithId({id: current, value: true});
			this.setFilterValueWithId({id: previous, value: true});
			this.setFilterValueWithId({id: next, value: true});
			this.setFilterValueWithId({id: oneTooLate, value: false});
			this.setFilterValueWithId({id: oneTooEarly, value: false});
			this.executeSearch();
		},
		unfilterMonths(date) {
			let current = format(date, "LLLL_yyyy").toLowerCase();
			let previous = format(sub(date, {months: 1}), "LLLL_yyyy").toLowerCase();
			let next = format(add(date, {months: 1}), "LLLL_yyyy").toLowerCase();

			// This is to prevent the calendar from showing events from formerly selected months that arne't relevant to this new search
			let oneTooLate = format(add(date, {months: 2}), "LLLL_yyyy").toLowerCase();
			let oneTooEarly = format(sub(date, {months: 2}), "LLLL_yyyy").toLowerCase();

			this.setFilterValueWithId({id: current, value: false});
			this.setFilterValueWithId({id: previous, value: false});
			this.setFilterValueWithId({id: next, value: false});
			this.setFilterValueWithId({id: oneTooLate, value: false});
			this.setFilterValueWithId({id: oneTooEarly, value: false});
			this.executeSearch();

		},
		updateCalendarEvents(){
			this.calendarOptions.events = this.results.map(result => {
			let start = new Date(result.itemDate);
			let end = new Date(result.meta.endDate);
			if (!end || start.getTime() > end.getTime()) end = start;
			return {
				title: result.title,
				start,
				end,
				id: result.id,
				url: result.url
			}
		});
		}
	},
	created() {
		this.updateCalendarEvents();
	},
	mounted() {
		this.popupEl = document.querySelector(".app-popup");
	},
	beforeDestroy() {
		this.unfilterMonths(this.currentMonthDate);
	},
	watch:{
		results(newResults, oldResults) {
			this.updateCalendarEvents();
		},
	}
};
